import { Sun, Sunset, Moon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

// Fixed slot-code → icon mapping used everywhere a slot is rendered
// (CurrentSlotBanner, SlotPicker rows, SlotBadge) so the iconography stays
// consistent across the banner/modal/toast/table-cell surfaces.
const SLOT_ICON_MAP: Record<string, LucideIcon> = {
  S1: Sun,
  S2: Sun,
  S3: Sunset,
  S4: Moon,
  S5: Moon,
};

export const getSlotIcon = (code?: string | null): LucideIcon => SLOT_ICON_MAP[code ?? ''] ?? Sun;
